var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedlogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 51,
    viewBox: "0 0 70 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38477 2.3877L20.1367 47.7278C20.1436 47.7454 20.152 47.762 20.1634 47.7771C20.6925 48.4767 23.2107 48.4807 23.7629 47.7893C23.7811 47.7665 23.7925 47.7399 23.7997 47.7117L34.8184 5.10252C34.8846 4.8464 35.2499 4.85086 35.3099 5.10852L45.2155 47.6713C45.2225 47.7017 45.2344 47.7305 45.254 47.7547C45.8102 48.4437 48.3231 48.4388 48.8515 47.74C48.8629 47.7249 48.8715 47.708 48.8783 47.6904C56.0147 29.4737 60.0191 20.6136 67.1585 2.3877",
    stroke: "black",
    strokeWidth: 4.04874,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7891 2.8672L33.2743 45.8527C33.6059 46.7175 34.8286 46.7196 35.1632 45.8559L51.818 2.86719",
    stroke: "#DC2323",
    strokeWidth: 5.06093,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04492 2.0459L17.0452 2.0459",
    stroke: "#DC2323",
    strokeWidth: 4.09097,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8184 2.0459L67.5004 2.0459",
    stroke: "#DC2323",
    strokeWidth: 4.09097,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedlogo);
export default __webpack_public_path__ + "static/media/verifiedlogo.55814277e1f9d5c9ff1e77d409faf588.svg";
export { ForwardRef as ReactComponent };